import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import { CompanyProvider } from '@/contexts/CompanyContext';
import { DonationProvider } from '@/contexts/DonationContext';
import { CartProvider } from '@/contexts/CartContext';
import { ToastProvider } from '@/contexts/ToastContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { env } from '@/config/env';
import '@/styles/index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Only initialize Auth0 if configured
const auth0Config =
  env.auth0.domain && env.auth0.clientId
    ? {
        domain: env.auth0.domain,
        clientId: env.auth0.clientId,
        authorizationParams: {
          redirect_uri: env.auth0.redirectUri,
          audience: env.auth0.audience,
          scope: 'openid profile email picture',
        },
        useRefreshTokens: true,
        cacheLocation: 'localstorage' as const,
      }
    : null;

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      {auth0Config ? (
        <Auth0Provider {...auth0Config}>
          <AuthProvider>
            <CompanyProvider>
              <DonationProvider>
                <CartProvider>
                  <ToastProvider position="top-right" defaultDuration={5000}>
                    <App />
                  </ToastProvider>
                </CartProvider>
              </DonationProvider>
            </CompanyProvider>
          </AuthProvider>
        </Auth0Provider>
      ) : (
        <CompanyProvider>
          <DonationProvider>
            <CartProvider>
              <ToastProvider position="top-right" defaultDuration={5000}>
                <App />
              </ToastProvider>
            </CartProvider>
          </DonationProvider>
        </CompanyProvider>
      )}
    </BrowserRouter>
  </StrictMode>
);
